/**
 * Query Filter Component
 * 
 * A wrapper around the FilterBuilder component for SELECT queries
 */

import * as React from 'react';
import { FilterBuilder } from '../filter-builder';
import { ColumnRef } from '../../../data-grid/types';

interface QueryFilterProps {
  originalColumns: ColumnRef[];
  whereClause: string;
  onWhereChange: (where: string) => void;
}

/**
 * Query Filter Component
 * Allows users to filter data in a query
 */
export function QueryFilter({ 
  originalColumns, 
  whereClause, 
  onWhereChange 
}: QueryFilterProps) {
  return (
    <div className="h-full flex flex-col">
      <div className="flex items-center justify-between mb-2">
        <h4 className="text-xs font-medium text-muted-foreground">Filter options</h4>
      </div>
      
      <FilterBuilder
        columns={originalColumns}
        whereClause={whereClause}
        onWhereChange={onWhereChange}
        showAdvancedToggle={true}
        advancedPlaceholder="e.g. price > 100 AND category = 'Electronics'"
        advancedHelpText="Use SQL WHERE syntax for advanced filtering. Use AND/OR to combine conditions."
      />
    </div>
  );
} 